import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaArrowLeft } from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <motion.div 
        className="not-found-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1 
          className="not-found-title"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          404
        </motion.h1>
        
        <motion.h2 
          className="not-found-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          Page Not Found
        </motion.h2>
        
        <motion.p 
          className="not-found-description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          The page you're looking for seems to have wandered off on its own adventure. 
          Don't worry, we'll help you find your way back!
        </motion.p>
        
        <motion.div 
          className="not-found-actions"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <Link to="/" className="btn btn-primary">
            <FaHome />
            <span>Go Home</span>
          </Link>
          
          <button 
            onClick={() => window.history.back()} 
            className="btn btn-outline"
          >
            <FaArrowLeft />
            <span>Go Back</span>
          </button>
        </motion.div>
        
        <motion.div 
          className="not-found-suggestions"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1 }}
        >
          <h3>Popular Destinations</h3>
          <div className="suggestion-links">
            <Link to="/spiti-valley">Spiti Valley</Link>
            <Link to="/meghalaya">Meghalaya</Link>
            <Link to="/kashmir">Kashmir</Link>
            <Link to="/trekking-tours">Trekking Tours</Link>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFound;
